// extracted by mini-css-extract-plugin
export var checkbox = "_93-0";
export var circle = "_93-3";
export var horizontalContainer = "_93-7";
export var sm = "_93-5";
export var switch0 = "_93-2";
export var switchDisabled = "_93-8";
export var switchEnabled = "_93-1";
export var textSwitchContainer = "_93-9";
export var textSwitchOption = "_93-a";
export var textSwitchOptionSelected = "_93-b";
export var verticalContainer = "_93-6";
export var xs = "_93-4";